export default __webpack_public_path__ + "static/media/scotchbond-universal.9d828934.png";